import { Quote } from "lucide-react";
import { Reveal } from "../motion/Reveal.jsx";

export default function TestimonialCard({ testimonial, className = "" }) {
  return (
    <Reveal className={`flex h-full flex-col justify-between gap-8 rounded-xl border border-hairline bg-white p-8 md:p-10 ${className}`}>
      <div className="flex flex-col gap-6">
        <Quote className="h-7 w-7 text-brand" fill="currentColor" strokeWidth={0} />
        <p className="text-base leading-relaxed text-body md:text-lg">“{testimonial.quote}”</p>
      </div>
      <div className="flex flex-col gap-1">
        <span className="h-[2px] w-10 bg-brand" />
        <p className="pt-2 text-sm font-bold uppercase tracking-[0.18em] text-navy" data-testid={`testimonial-author-${testimonial.id}`}>
          {testimonial.name}
        </p>
        <p className="text-xs uppercase tracking-[0.18em] text-faint">Oneiros Member</p>
      </div>
    </Reveal>
  );
}
